import React, { ReactNode } from "react";

import { IconType } from "react-icons";
import { Container, Group, Heading, Text, Title } from "./styles";

interface BoxProps {
  style?: React.CSSProperties;
  children?: ReactNode;
}

export const Box: React.FC<BoxProps> = ({ children, ...rest }) => {
  return <Container {...rest}>{children}</Container>;
};

interface BoxHeadingProps {
  children?: ReactNode;
  style?: React.CSSProperties;
  icon?: IconType;
}
export const BoxHeading: React.FC<BoxHeadingProps> = ({
  children,
  ...rest
}) => {
  return (
    <Heading {...rest}>
      {rest.icon && <rest.icon style={{ marginRight: "0.5rem" }} />}
      {children}
    </Heading>
  );
};

interface BoxGroupProps {
  children: ReactNode;
  direction?: "vertical" | "horizontal";
}
export const BoxGroup: React.FC<BoxGroupProps> = ({
  children,
  direction = "horizontal",
}) => {
  return (
    <Group
      style={{ flexDirection: direction === "horizontal" ? "row" : "column" }}
    >
      {children}
    </Group>
  );
};

interface BoxTextProps {
  children?: ReactNode;
  style?: React.CSSProperties;
  icon?: IconType;
}
export const BoxText: React.FC<BoxTextProps> = ({ children, ...rest }) => {
  return (
    <Text {...rest}>
      {rest.icon && <rest.icon style={{ marginRight: "0.5rem" }} />}
      {children}
    </Text>
  );
};

interface BoxTitleProps {
  children?: ReactNode;
  style?: React.CSSProperties;
}
export const BoxTitle: React.FC<BoxTitleProps> = ({ children, ...rest }) => {
  return <Title {...rest}>{children}</Title>;
};
